export default __webpack_public_path__ + "static/media/meet-bg.64ef14d3.png";